<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.carrier', 2) }}
          <v-btn color="primary" @click="goTo('agreementCarriers')"> {{ $t('create') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.id }} </td>
            <td> {{ props.item.name }} </td>
            <td> {{ props.item.provider.name }} </td>
            <td>
              <StatusChip :status="props.item.status" outline></StatusChip>
            </td>
            <td class="pa-0 pr-2 text-xs-right">

                <v-btn color="success" slot="activator" flat icon @click="activate(props.item)" v-if="props.item.status !== 'active'">
                  <font-awesome-icon icon="check"></font-awesome-icon>
                </v-btn>

              <v-btn color="red" flat icon @click="suspend(props.item)" v-if="props.item.status !== 'suspended'">
                <font-awesome-icon icon="ban"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat icon @click="goTo('clientCarrierForm', { id: props.item.id })">
                <font-awesome-icon icon="cog"></font-awesome-icon>
              </v-btn>

              <v-btn color="red" flat icon @click="destroy(props.item)" v-can:destroy="'Carrier'">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
import Setting from '@/client/setting'

export default {
  name: 'CarriersView',

  props: {},

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'id', width: '5%' },
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$tc('models.provider'), align: 'left', sortable: true, value: 'provider.name' },
        { text: this.$t('attrs.status'), align: 'left', sortable: true, value: 'status' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      this.items = await Carrier.all({ include: 'provider', per_page: 2000, where: { user_id: this.$auth.currentUser.id}, own_agreements: true })
      this.loading = false
    },

    async activate (carrier) {
      try {
        carrier.status = 'active'
        await carrier.save()
      } catch (err) {
        // empty
      }
      this.fetch()
    },

    async suspend (carrier) {
      try {
        carrier.status = 'suspended'
        await carrier.save()
      } catch (err) {
        // empty
      }
      this.fetch()
    },

    async exportCarrierInfo (carrier) {
      try {
        const data = await Carrier.exportCarrierInfo(carrier.id)
        this.downloadFile(data, `${carrier.name}-carrier.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
    },

    confirmation (carrier) {
      return window.confirm(this.$t('deleteConfirmation', { name: carrier.name, obj: this.$tc('models.carrier', 1).toLowerCase() }))
    },

    async destroy (carrier) {
      try {
        if ( this.confirmation(carrier) ) {
          await Carrier.destroyById(carrier.id)
          this.fetch()
        }
      } catch (err) {
      }
    },

    confirmation (carrier) {
      return window.confirm(this.$t('deleteConfirmation', { name: carrier.name, obj: this.$tc('models.carrier', 1).toLowerCase() }))
    }
  },

  watch: {
  },

  async mounted () {
    var ownAgreements = await Setting.byKey('user_own_agreements') || {}
    if (ownAgreements && ownAgreements.value == '0') this.goTo('dashboard')

    this.fetch()
  }
}
</script>
